@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-toolbar>
  <mat-icon mat-list-icon>directions_car</mat-icon>
  <span class="container-fluid">
    <h1>
      @if (data.edit) {
        <span>{{ 'FORM.EDIT' | transloco }}</span>
      }
      @if (!data.edit) {
        <span>{{ 'FORM.CREATE' | transloco }}</span>
      }
      {{ 'VEHICLE_MANAGEMENT.TITLE' | transloco }}
    </h1>
  </span>
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <form [formGroup]="vehicleForm" (ngSubmit)="saveChanges()">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'VEHICLE_MANAGEMENT.VEHICLE_NUMBER' | transloco }}</mat-label>
      <input matInput [placeholder]="'VEHICLE_MANAGEMENT.VEHICLE_NUMBER_PLACEHOLDER' | transloco"
        formControlName="regNo" maxlength="10" (input)="formatVehicleNumber($event)">
      <mat-icon matSuffix>directions_car</mat-icon>
      @if (vehicleForm.get('regNo')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('VEHICLE_MANAGEMENT.VEHICLE_NUMBER' | transloco) } }}
        </mat-error>
      }
      @if (vehicleForm.get('regNo')?.hasError('maxlength')) {
        <mat-error>
          {{ 'FORM.VALIDATION.MAX_LENGTH' | transloco: { field: ('VEHICLE_MANAGEMENT.VEHICLE_NUMBER' | transloco), max: 10
          } }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'VEHICLE_MANAGEMENT.GATES' | transloco }}</mat-label>
      <mat-select formControlName="gates" multiple>
        @for (gate of data.gates; track gate) {
          <mat-option [value]="gate.id">
            {{gate?.description}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'VEHICLE_MANAGEMENT.COMMENT' | transloco }}</mat-label>
      <input matInput [placeholder]="'VEHICLE_MANAGEMENT.COMMENT_PLACEHOLDER' | transloco" formControlName="comment">
      <mat-icon matSuffix>comment</mat-icon>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-dialog-close>{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-button color="primary" type="submit" (click)="saveChanges()">
    {{ 'VEHICLE_MANAGEMENT.SAVE_CHANGES' | transloco }}
  </button>
</mat-dialog-actions>